module.exports = __webpack_public_path__ + "img/economia.bf2fce64.svg";